import { api, setActivation } from 'services/api';
import { createRestProvider } from './restProvider';

export const locationsDataProvider = createRestProvider();

const toNumber = (value: unknown) => {
  if (value === undefined || value === null || value === '') return undefined;
  const num = Number(value);
  return Number.isFinite(num) ? num : undefined;
};

locationsDataProvider.getOne = async ({ id }) => {
  const { data: location } = await api.get<{ data: Record<string, any> }>(
    `/admin/locations/${id}`
  );

  const geometry = location.geometry
    ? {
        ...location.geometry,
        coordinates:
          typeof location.geometry.coordinates === 'string'
            ? JSON.parse(location.geometry.coordinates)
            : location.geometry.coordinates
      }
    : null;

  return {
    data: {
      id: location.id,
      key: location.key,
      country: location.country,
      name: location.name,
      country_name: location.countryName,
      sygic_id: location.sygicId,
      name_local: location.nameLocal,
      level: location.level,
      rating: location.rating,
      rating_local: location.ratingLocal,
      quad_key: location.quadKey,
      perex: location.perex,
      tag_keys: location.tagKeys || [],
      categories: location.categories || [],
      hotel_star_rating: location.hotelStarRating,
      customer_rating: location.customerRating,
      // flat list, ParentTree builds the nested tree itself
      place_parents: location.placeParents,
      location: location.location
        ? { lat: location.location.latitude, lng: location.location.longitude }
        : null,
      geometry,
      is_active: location.isActivated
    } as any
  };
};

locationsDataProvider.update = async ({ variables, id }) => {
  const values: Record<string, any> = variables as any;
  const body: Record<string, unknown> = {};

  // Only the fields the API accepts (key, sygic_id, level, quad_key,
  // geometry, location and place_parents are read-only)
  const plain: Record<string, string> = {
    name: 'name',
    country_name: 'countryName',
    name_local: 'nameLocal',
    perex: 'perex',
    tag_keys: 'tagKeys',
    categories: 'categories',
    rating: 'rating',
    rating_local: 'ratingLocal'
  };
  Object.entries(plain).forEach(([key, apiKey]) => {
    if (values[key] !== undefined && values[key] !== null) {
      body[apiKey] = ['rating', 'ratingLocal'].includes(apiKey)
        ? String(values[key])
        : values[key];
    }
  });

  const numeric: Record<string, string> = {
    hotel_star_rating: 'hotelStarRating',
    customer_rating: 'customerRating'
  };
  Object.entries(numeric).forEach(([key, apiKey]) => {
    const num = toNumber(values[key]);
    if (num !== undefined) body[apiKey] = num;
  });

  const { is_active: isActivated } = values;

  if (Object.keys(body).length === 0 && isActivated !== undefined) {
    const { data } = await setActivation<{ data: any }>(
      'locations',
      id,
      isActivated
    );
    return { data };
  }

  if (isActivated !== undefined) {
    body.isActivated = isActivated;
  }

  const { data } = await api.patch<{ data: any }>(
    `/admin/locations/${id}`,
    body
  );
  return { data };
};
